import { useI18N } from '@susu/i18n/client'
import { Button, Icon } from '@susu/ui/components'

import { ScreenLayout } from './ScreenLayout'

interface SlotUnavailableProps {
  onClose?: () => void
  /** Header back arrow and the primary button both send the user back to slot selection. */
  onChooseNewSlot: () => void
}

/**
 * Full-screen state shown when the API rejects a create/update booking because
 * the chosen slot filled up in the meantime (see `isSlotUnavailableError`).
 */
export const SlotUnavailable = ({
  onClose,
  onChooseNewSlot,
}: SlotUnavailableProps) => {
  const { t } = useI18N()

  return (
    <ScreenLayout onClose={onClose} onBack={onChooseNewSlot}>
      <div
        className="flex-1 flex flex-col items-center justify-center gap-20 px-32 text-center"
        data-testid="user-data-slot-unavailable"
      >
        <span
          className="inline-flex items-center justify-center rounded-full border border-[#E1E1E1] p-8 box-content text-text"
          aria-hidden="true"
        >
          <Icon name="calendar" size={20} />
        </span>
        <div className="flex flex-col gap-12">
          <h2 className="text-[20px] leading-[30px] font-medium text-text tracking-[-0.3px]">
            {t('userData.slotUnavailable.title')}
          </h2>
          <p className="text-base leading-[24px] font-light text-text">
            {t('userData.slotUnavailable.body')}
          </p>
        </div>
      </div>
      <div className="shrink-0 -mx-16 px-20 pt-20 pb-[calc(20px+env(safe-area-inset-bottom,0px))]">
        <Button
          className="w-full"
          size="l"
          onClick={onChooseNewSlot}
          data-testid="user-data-choose-new-slot"
        >
          {t('userData.slotUnavailable.button')}
        </Button>
      </div>
    </ScreenLayout>
  )
}
